module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_library.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_library.js
// module chunks = 6